import { render, staticRenderFns } from "./PayRangeVersionRowCard.vue?vue&type=template&id=550a9a46"
import script from "./PayRangeVersionRowCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeVersionRowCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports